export const debounce = (callback: any, wait: number) => {
  let timeoutId: number;
  return (...args: any) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
};
